module.exports = __webpack_public_path__ + "static/screen-xd-1-b57c07ec604e4497c546cc9f73d44683.png";